import React from 'react';
import PropTypes from 'prop-types';
import usMap from '@assets/images/us-map.svg';

ImpactStatement.propTypes = {
  kicker: PropTypes.node,
  stat: PropTypes.node,
  description: PropTypes.node,
  mapAlt: PropTypes.string
};

export default function ImpactStatement(props) {
  const {
    kicker = 'CommunityShare has connected',
    stat = '105,000+ learners',
    description = 'to meaningful, real-world learning experiences across 12 states',
    mapAlt = "Map showing CommunityShare's presence across US states"
  } = props;

  return (
    <>
      {/* Mobile: stacked vertical — text then map below */}
      <div className="block md:hidden">
        <div className="w-full max-w-screen-xl mx-auto bg-cs-navy-600 rounded-cs-10 overflow-hidden px-5 py-6 flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <p className="text-cs-orange-50 text-2xl font-semibold leading-tight">{kicker}</p>
            <p className="text-cs-orange-50 text-4xl font-bold leading-tight">{stat}</p>
            <p className="text-cs-orange-50 text-2xl font-normal leading-tight">{description}</p>
          </div>
          <img
            src={usMap}
            alt={mapAlt}
            className="w-full select-none"
            draggable={false}
          />
        </div>
      </div>

      {/* Desktop + Tablet: text left, map right */}
      <div className="hidden md:block">
        <div className="w-full max-w-screen-xl mx-auto bg-cs-navy-600 rounded-cs-10 overflow-hidden">
          <div className="flex flex-row items-stretch gap-12">

            {/* Left — text with padding */}
            <div className="flex-1 min-w-0 flex flex-col justify-center gap-3 pl-9 py-8">
              <p className="text-cs-orange-50 text-2xl font-semibold leading-tight">{kicker}</p>
              <p className="text-cs-orange-50 text-4xl font-bold leading-tight">{stat}</p>
              <p className="text-cs-orange-50 text-2xl font-normal leading-tight">{description}</p>
            </div>

            {/* Right — map, no padding, bleeds to all container edges */}
            <div className="flex-1 min-w-0">
              <img
                src={usMap}
                alt={mapAlt}
                className="w-full h-auto block select-none"
                draggable={false}
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
